<template>
   <div class="main">
      <div class="breadcrumb">
         <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>装备</el-breadcrumb-item>
            <el-breadcrumb-item>装备MSRP数据</el-breadcrumb-item>
         </el-breadcrumb>
      </div>
      <SearchBar :moduleName="currentModuleName" v-if="!viewResult">
         <el-button @click="test" type="primary">装备MSRP</el-button>
      </SearchBar>
      <div v-if="viewResult" style="margin-top:40px;">
         <xy-toolbox-menu>
            <xy-toolbox-menu-item divided></xy-toolbox-menu-item>
            <xy-toolbox-menu-item icon="delete" @click="test">删除</xy-toolbox-menu-item>
            <xy-toolbox-menu-item icon="saveas" @click="test">另存为</xy-toolbox-menu-item>
            <xy-toolbox-menu-item icon="save">保存</xy-toolbox-menu-item>
            <xy-toolbox-menu-item icon="excel">导出</xy-toolbox-menu-item>
         </xy-toolbox-menu>
         <el-table :data="tableData" :span-method="objectSpanMethod" border height="650" style="width: 98%; margin:20px 10px 10px 10px;">
            <el-table-column prop="tag" label="装备分类" align="center" width="180"> </el-table-column>
            <el-table-column prop="name" label="装备名称"></el-table-column>
            <el-table-column prop="val" label="装备名称"></el-table-column>
            <el-table-column align="center" label="MSRP">
               <el-table-column icon="el-icon-search" align="center" :prop="n" :key="n" :label="n" v-for='n in date_list'>
               </el-table-column>
            </el-table-column>
         </el-table>
      </div>
   </div>
</template>

<script>
   import {
      mapMutations,
      mapGetters,
      mapActions
   } from 'vuex';
   import SearchBar from '@/components/common/NewSearchBar.vue';
   export default {
      name: 'saleanalysis',
      components: {
         SearchBar
      },
      data() {
         return {
            viewResult: true,
            currentModuleName: '',
         }
      },
      methods: {
         test() {
         },
      }
   }
</script>
 